import React from 'react';
import { Carousel, Container } from 'react-bootstrap';
import nikeair from '../images/nikeair.jpg';
import clasic from '../images/clasic.jpg';
import yezzy from '../images/yezzy.jpg';

export default function Hero() {
  return (
    <Container fluid className='hero'>
      {/* <section className='hero'> */}
      <Carousel className=''>
        <Carousel.Item>
          <img className='d-block w-100' src={nikeair} alt='First slide' />
          <Carousel.Caption>
            <h3>Nike Collecioon</h3>
            <p>We have all kinds of nike sneakers collection</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className='d-block w-100' src={yezzy} alt='Second slide' />

          <Carousel.Caption>
            <h3>Adidas Collection</h3>
            <p>From Yezzy to Stan Smith we have it!</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img className='d-block w-100' src={clasic} alt='Third slide' />
          <Carousel.Caption>
            <h3>Classic Colection</h3>
            <p>
              Throw back Thursday? Make it slick with our classic collection
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
      {/* </section> */}
    </Container>
  );
}
